import React, { useState } from 'react';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { requestPaymentChange } from '../../API/changeRequest';
import {
  getStepHeader,
  getStepDescription,
  remittanceDialogSteps,
} from './Utils';
import { deleteAllFiles } from '../../uploadDocument/UploadCard';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';
import moment from 'moment';
import messages from '../../../messages';
import DialogActions from './DialogActions';
import DialogChildren from './DialogChildren';

export default function RequestChangeDialog({
  setDisableEditButton,
  paymentDialogOpen,
  setPaymentDialogOpen,
  stepNumber,
  setStepNumber,
  payment,
  setLoading,
  setReviewPayment,
}) {
  const snackbar = useSnackbarContext();
  const { trackEvent } = useEventTrackerContext();
  const [message, setMessage] = useState('');
  const [ids, setIds] = useState([]);
  const [disableLoadingButtons, setDisableLoadingButtons] = useState(false);
  const [date, setDate] = useState(null);

  async function onClosePaymentDialog(deleteFiles = false) {
    setPaymentDialogOpen(false);
    setMessage('');
    setIds([]);
    setTimeout(
      () => setStepNumber(remittanceDialogSteps.remittanceDetails),
      500,
    );
    if (deleteFiles && ids.length > 0) {
      await deleteAllFiles(ids);
    }
  }

  const submitRequest = async () => {
    setLoading(true);
    setDisableLoadingButtons(true);
    setDisableEditButton(true);

    try {
      await requestPaymentChange(
        payment.relatedOperationPayments,
        moment(date).toDate(),
        message,
        ids,
      );
      setReviewPayment(payment);
    } catch (error) {
      return snackbar.show(messages.general.saveError, 'error');
    }
    trackEvent({ event: 'payments_change_requested', payment });
    snackbar.show(messages.lines.changeActiveLineRequestSuccess, 'success');
    setLoading(false);
    setDisableLoadingButtons(false);
    setStepNumber(remittanceDialogSteps.submitRequest);
  };

  return (
    <>
      <Dialog
        open={paymentDialogOpen}
        header={getStepHeader(stepNumber)}
        description={getStepDescription(stepNumber)}
        children={
          <DialogChildren
            step={stepNumber}
            startDate={payment.startDate}
            date={date}
            setDate={setDate}
            message={message}
            setMessage={setMessage}
            ids={ids}
            setIds={setIds}
          />
        }
        actions={
          <DialogActions
            step={stepNumber}
            setStepNumber={setStepNumber}
            date={date}
            onCancel={onClosePaymentDialog}
            loading={disableLoadingButtons}
            submitRequest={submitRequest}
            message={message}
          />
        }
        onClose={() => onClosePaymentDialog()}
      />
    </>
  );
}
